export default __webpack_public_path__ + "static/coming-soon-8039534d7204547786a82883876b59ed.jpg";